import { render, staticRenderFns } from "./ReportDetailsSelector.vue?vue&type=template&id=2ae4779e&scoped=true&"
import script from "./ReportDetailsSelector.vue?vue&type=script&lang=js&"
export * from "./ReportDetailsSelector.vue?vue&type=script&lang=js&"
import style0 from "./ReportDetailsSelector.vue?vue&type=style&index=0&id=2ae4779e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae4779e",
  null
  
)

export default component.exports